import { render, staticRenderFns } from "./bank-accounts.page.vue?vue&type=template&id=5c84c0fa&"
import script from "./bank-accounts.page.vue?vue&type=script&lang=ts&"
export * from "./bank-accounts.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports